import type { HTMLAttributes, ReactNode } from "react";
import { injectCss } from "./injectCss";

const CSS = `
.js-badge{
  display:inline-flex;align-items:center;gap:5px;
  font-family:var(--font-sans);font-weight:var(--weight-bold);
  font-size:var(--text-micro);line-height:1;
  padding:4px 9px;border-radius:var(--radius-pill);
  font-variant-numeric:tabular-nums;white-space:nowrap;
}
.js-badge .js-badge__dot{width:6px;height:6px;border-radius:50%;background:currentColor}
.js-badge--neutral{background:var(--neutral-100);color:var(--text-muted)}
.js-badge--brand{background:var(--brand-subtle);color:var(--teal-700)}
.js-badge--accent{background:var(--accent-subtle);color:var(--apricot-700)}
.js-badge--success{background:var(--success-bg);color:var(--success-fg)}
.js-badge--warning{background:var(--warning-bg);color:var(--warning-fg)}
.js-badge--danger{background:var(--danger-bg);color:var(--danger-fg)}
.js-badge--info{background:var(--info-bg);color:var(--info-fg)}
.js-badge--solid{background:var(--brand);color:#fff}
`;

export type BadgeTone = "neutral" | "brand" | "accent" | "success" | "warning" | "danger" | "info" | "solid";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  dot?: boolean;
  children?: ReactNode;
}

export function Badge({ tone = "neutral", dot = false, className = "", children, ...rest }: BadgeProps) {
  injectCss("js-badge-css", CSS);
  const cls = ["js-badge", `js-badge--${tone}`, className].filter(Boolean).join(" ");
  return (
    <span className={cls} {...rest}>
      {dot && <span className="js-badge__dot" />}
      {children}
    </span>
  );
}
